<template>
  <div class="product-format-full">
    <div
      class="out-of-stock"
      v-if="product_formats.dp.length < 1 && product_formats.ib.length < 1"
    >
      <div class="product-stock-level low-stock mb-2">Out of stock</div>
    </div>
    <b-tabs
      id="product-duty-tabs"
      v-else
      content-class="product-duty-tabs-content"
    >
      <b-tab
        title="Retail"
        v-if="product_formats.dp.length > 0"
        :active="currentDuty === 'DP'"
        @click="changeDuty('DP')"
      >
        <product-format
          v-for="(product, index) in product_formats.dp"
          :key="index"
          :product="product"
        ></product-format>
      </b-tab>
      <b-tab
        title="In Bond"
        v-if="product_formats.ib.length > 0"
        :active="currentDuty === 'IB'"
        @click="changeDuty('IB')"
      >
        <product-format
          v-for="(product, index) in product_formats.ib"
          :key="index"
          :product="product"
        ></product-format>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Vue from "vue";
import { TabsPlugin } from "bootstrap-vue";

import ProductFormat from "@/components/ProductFormatNormalised";

Vue.use(TabsPlugin);

export default {
  data() {
    return {
      product_formats: { dp: [], ib: [] },
    };
  },
  components: {
    ProductFormat,
  },
  methods: {
    changeDuty(duty) {
      document.dispatchEvent(
        new CustomEvent("jb_duty_changed", { detail: duty })
      );
    },
  },
  mounted() {
    this.product_formats = JSON.parse(this.formats);
    // var items = [];

    // for(var duty in this.product_formats) {
    //   for(var i in this.product_formats[duty]) {
    //   items.push({
    //       id: this.product_formats[duty][i].id,
    //       name: this.product_formats[duty][i].title,
    //       list_name: "Product Duty Tabs",
    //       brand: "Google",
    //       category: "Apparel/T-Shirts",
    //       variant: "Black",
    //       list_position: 1,
    //       quantity: 2,
    //       price: 2,
    //   });
    //   }
    // }

    // gtag("event", "select_content", {
    //   content_type: "product",
    //   items: items,
    // });
  },
  props: {
    currentDuty: {
      type: String,
      default: "DP",
    },
    productId: String,
    formats: String,
  },
};
</script>